import base from './base';
import palette from './palette';

const link = {
  MuiLink: {
    styleOverrides: {
      root: {
        '&:hover': {
          color: palette.primary.light,
        },
        '&:active': {
          color: palette.primary.dark,
        },
        '&:focus-visible': {
          backgroundColor: palette.red[100],
          borderRadius: base.shape.borderRadius,
          color: palette.primary.light,
          outline: '1px dashed' + palette.primary.main,
          outlineOffset: 0,
        },
      },
    },
  },
};

export default link;
